<template>
  <div class="layout-container">
    
    <aside v-show="panels.show.left" class="left-panel shadow-lg">
      <!-- 목록으로 돌아가기 버튼 -->
      <div class="tool-item first-tool-item" @click="goBackToList">
        <button 
          @click.stop="goBackToList" 
          class="back-button"
          title="목록으로 돌아가기"
        >
          <i class="fa fa-arrow-left" aria-hidden="true"></i>
        </button>
        <span class="tool-label">목록으로 돌아가기</span>
      </div>
      <hr />
      
      <div v-show="mode == 'segment'">
        <hr />
        
        <div class="tool-item" @click="handleInferenceClick">
          <InferenceButton ref="inference" @inference-started="startInferenceStatusPolling" />
          <span class="tool-label">안저사진 분석</span>
        </div>
        <hr />  
          
        <div class="tool-item" @click="handleSelectToolClick">
          <SelectTool
            v-model="activeTool"
            :scale="image.scale"
            :key="`select-${image.id}`"
            @setcursor="setCursor"
            ref="select"
          />
          <span class="tool-label">선택 도구</span>
        </div>
          
        <hr />
        <div class="tool-item" @click="handleCenterClick">
          <CenterButton ref="center" />
          <span class="tool-label">이미지 중앙 정렬</span>
        </div>
          
        <hr />  
        <div class="tool-item" @click="handleDownloadClick">
          <DownloadButton :image="image" ref="download" />
          <span class="tool-label">다운로드</span>
        </div>
        
        <hr />
        <div class="tool-item" @click="handleDeleteClick">
          <DeleteButton :image="image" ref="delete" />
          <span class="tool-label">이미지 삭제</span>
        </div>
          
        <BBoxTool
          v-model="activeTool"
          :scale="image.scale"
          @setcursor="setCursor"
          ref="bbox"
        />

        <PolygonTool
          v-model="activeTool"
          :scale="image.scale"
          @setcursor="setCursor"
          ref="polygon"
        />

        <MagicWandTool
          v-model="activeTool"
          :width="image.raster.width"
          :height="image.raster.height"
          :image-data="image.data"
          @setcursor="setCursor"
          ref="magicwand"
        />

        <BrushTool
          v-model="activeTool"
          :scale="image.scale"
          @setcursor="setCursor"
          ref="brush"
        />
        <EraserTool
          v-model="activeTool"
          :scale="image.scale"
          @setcursor="setCursor"
          ref="eraser"
        />

        <KeypointTool
          v-model="activeTool"
          @setcursor="setCursor"
          ref="keypoint"
        />
        
        <DEXTRTool
          v-model="activeTool"
          :scale="image.scale"
          @setcursor="setCursor"
          ref="dextr"
        />
      </div>

      <hr />

      <AnnotateButton :annotate-url="dataset.annotate_url" />

      <div v-show="mode == 'segment'">
        <ShowAllButton />
        <HideAllButton />
      </div>

      <UndoButton />
    
      <CopyAnnotationsButton
        :categories="categories"
        :image-id="image.id"
        :next="image.next"
        :previous="image.previous"
      />  

      <ModeButton v-model="mode" />
      <SettingsButton
        :metadata="image.metadata"
        :commands="commands"
        ref="settings"
      />

    </aside>

    <div class="middle-panel" :style="{ cursor: cursor }">
      <v-touch @pinch="onpinch" @pinchstart="onpinchstart">
        <div id="frame" class="frame" @wheel="onwheel">
          <canvas class="canvas" id="editor" ref="image" resize />
        </div>
      </v-touch>   
    </div>

    <aside v-show="panels.show.right" class="right-panel shadow-lg">
      
      <hr />

      <p class="text-center" style="color: lightgray">
        <strong style="color: white">{{ image.prediction_status }}</strong>
      </p>

      <FileTitle
        :previousimage="image.previous"
        :nextimage="image.next"
        :filename="image.filename"
        ref="filetitle"
      />
    
      <div
        class="sidebar-section"
        :style="{ 'max-height': '95%'}"
      >
        <div
            class="sidebar-section"
            v-if="image.predicted == true"
        >
          <hr/>
          <img 
               class='thumbnail' 
               :src="getURL()"
               @click="openAnnotator"
          >
          <div v-for="id in this.image.results_list_id" :key="id">
            <hr/>
            <img 
                class='thumbnail'
                :src="getURL_result(id)"
                @click="openAnnotator_result(id)"
            >
          </div>
          <hr/>
        </div>
          
        </div>

      <div v-show="mode == 'segment'">
        </div>
    </aside>

    </div>
</template>

<script>
import paper from "paper";
import axios from '@/libs/axios'
import toastrs from "@/mixins/toastrs";
import shortcuts from "@/mixins/shortcuts";
import FileTitle from "@/components/annotator/FileTitle";
import Annotations from "@/models/annotations";
import PolygonTool from "@/components/annotator/tools/PolygonTool";
import BBoxTool from "@/components/annotator/tools/BBoxTool";
import SelectTool from "@/components/annotator/tools/SelectTool";
import MagicWandTool from "@/components/annotator/tools/MagicWandTool";
import BrushTool from "@/components/annotator/tools/BrushTool";
import EraserTool from "@/components/annotator/tools/EraserTool";
import KeypointTool from "@/components/annotator/tools/KeypointTool";
import DEXTRTool from "@/components/annotator/tools/DEXTRTool";
import CopyAnnotationsButton from "@/components/annotator/tools/CopyAnnotationsButton";
import CenterButton from "@/components/annotator/tools/CenterButton";
import DownloadButton from "@/components/annotator/tools/DownloadButton";
import InferenceButton from "@/components/annotator/tools/InferenceButton";
import SettingsButton from "@/components/annotator/tools/SettingsButton";
import ModeButton from "@/components/annotator/tools/ModeButton";
import DeleteButton from "@/components/annotator/tools/DeleteButton";
import UndoButton from "@/components/annotator/tools/UndoButton";
import ShowAllButton from "@/components/annotator/tools/ShowAllButton";
import HideAllButton from "@/components/annotator/tools/HideAllButton";
import AnnotateButton from "@/components/annotator/tools/AnnotateButton";
import { mapMutations } from "vuex";
import {
  FAILED,
  TERMINAL_PREDICTION_STATUSES,
} from '@/libs/predictionStatus';

export default {
  name: "Annotator",
  components: {
    FileTitle,
    CopyAnnotationsButton,
    BBoxTool,
    PolygonTool,
    SelectTool,
    MagicWandTool,
    BrushTool,
    EraserTool,
    KeypointTool,
    DownloadButton,
    InferenceButton,
    SettingsButton,
    DeleteButton,
    CenterButton,
    ModeButton,
    UndoButton,
    HideAllButton,
    ShowAllButton,
    AnnotateButton,
    DEXTRTool,
  },
  mixins: [toastrs, shortcuts],
  props: {
    identifier: {
      type: [Number, String],
      required: true
    }
  },
  data() {
    return {
      activeTool: "Select",
      paper: null,
      shapeOpacity: 0.6,
      zoom: 0.2,
      cursor: "move",
      mode: "segment",
      simplify: 1,
      panels: {
        show: {
          left: true,
          right: true
        }
      },
      current: {
        category: -1,
        annotation: -1,
        keypoint: -1,
      },
      hover: {
        category: -1,
        annotation: -1,
        keypoint: -1,
      },
      inferencePollingTimer: null,
      inferencePollingStartedAt: null,
      image: {
        raster: {},
        scale: 0,
        metadata: {},
        ratio: 0,
        rotate: 0,
        id: null,
        url: "",
        dataset: 0,
        previous: null,
        next: null,
        filename: "",
        categoryIds: [],
        data: null,
        predicted: false,
        results: {},
        results_list_id: [],
        original_id: 0,
        prediction_status: ''
      },
      text: {
        topLeft: null,
        topRight: null
      },
      categories: [],
      dataset: {
        annotate_url: ""
      },
      loading: {
        image: true,
        data: true,
        loader: null
      },
      search: "",
      annotating: [],
      pinching: {
        old_zoom: 1
      }
    };
  },
  methods: {
    ...mapMutations(["addProcess", "removeProcess", "resetUndo", "setDataset"]),
    getURL(){
      return "/api/image/" + this.image.id;
    },
    getURL_result(id){
        return "/api/resultAI/" + id;
    },
    openAnnotator() {
      if(this.image.url=="/api/image/" + this.image.id)
      {
        return 0;
      }
      else
      {
        this.paper.clear()
        this.paper.remove()
        delete this.paper;
        this.paper = new paper.PaperScope();
        this.image.url = "/api/image/" + this.image.id;
        this.initCanvas();
      }
    },
    openAnnotator_result(id) {
      if(this.image.url=="/api/resultAI/" + id)
      {
        return 0;
      }
      else
      {
        this.paper.clear()
        this.paper.remove()
        delete this.paper;
        this.paper = new paper.PaperScope();
        this.image.id = this.identifier;
        this.image.url = "/api/resultAI/" + id;
        this.initCanvas();
      }
    },
    save(callback) {
      if (callback != null) callback();
      return 
    },
    onpinchstart(e) {
      e.preventDefault();
      if (!this.doneLoading) return;
      this.pinching.old_zoom = this.paper.view.zoom;
      return false;
    },
    onpinch(e) {
      e.preventDefault();
      if (!this.doneLoading) return;
      let view = this.paper.view;
      let viewPosition = view.viewToProject(
        new paper.Point(e.center.x, e.center.y)
      );
      let curr_zoom = e.scale * this.pinching.old_zoom;
      let beta = this.paper.view.zoom / curr_zoom;
      let pc = viewPosition.subtract(this.paper.view.center);
      let a = viewPosition.subtract(pc.multiply(beta)).subtract(this.paper.view.center);  
      let transform = {zoom: curr_zoom, offset: a}
      if (transform.zoom < 10 && transform.zoom > 0.01) {
        this.image.scale = 1 / transform.zoom;
        this.paper.view.zoom = transform.zoom;
        this.paper.view.center = view.center.add(transform.offset);
      }
      return false;
    },
    onwheel(e) {
      e.preventDefault();
      if (!this.doneLoading) return;

      let view = this.paper.view;

      if (e.ctrlKey) {
        // Pan up and down
        let delta = new paper.Point(0, 0.5 * e.deltaY);
        this.paper.view.setCenter(view.center.add(delta));
      } else if (e.shiftKey) {
        // Pan left and right
        let delta = new paper.Point(0.5 * e.deltaY, 0);
        this.paper.view.setCenter(view.center.add(delta));
      } else {
        let viewPosition = view.viewToProject(
          new paper.Point(e.offsetX, e.offsetY)
        );

        let transform = this.changeZoom(e.deltaY, viewPosition);
        if (transform.zoom < 10 && transform.zoom > 0.01) {
          this.image.scale = 1 / transform.zoom;
          this.paper.view.zoom = transform.zoom;
          this.paper.view.center = view.center.add(transform.offset);
        }
      }

      return false;
    },
    fit() {
      let canvas = document.getElementById("editor");
      
      // canvas가 아직 준비되지 않았으면 리턴
      if (!canvas) {
        return;
      }

      // 캔버스의 실제 크기를 가져옴 (CSS로 100% 된 상태여야 함)
      let containerWidth = canvas.offsetWidth;
      let containerHeight = canvas.offsetHeight;
      
      // 크기가 0이면 리턴
      if (containerWidth === 0 || containerHeight === 0) {
        return;
      }
      
      let imageWidth = this.image.raster.width;
      let imageHeight = this.image.raster.height;

      // 가로 기준 비율과 세로 기준 비율 중 더 '작은' 쪽을 선택해야 이미지가 안 잘리고 다 들어옴
      let scaleX = (containerWidth / imageWidth) * 0.95; // 여백 5%
      let scaleY = (containerHeight / imageHeight) * 0.95;
      
      this.paper.view.zoom = Math.min(scaleX, scaleY);

      this.image.scale = 1 / this.paper.view.zoom;
      this.paper.view.setCenter(0, 0);
    },
    changeZoom(delta, p) {
      let oldZoom = this.paper.view.zoom;
      let c = this.paper.view.center;
      let factor = 1 + this.zoom;

      let zoom = delta < 0 ? oldZoom * factor : oldZoom / factor;
      let beta = oldZoom / zoom;
      let pc = p.subtract(c);
      let a = p.subtract(pc.multiply(beta)).subtract(c);

      return { zoom: zoom, offset: a };
    },

    initCanvas() {
      let process = "Initializing canvas";
      this.addProcess(process);
      this.loading.image = true;

      let canvas = document.getElementById("editor");
      
      // canvas가 아직 준비되지 않았으면 다음 틱에 다시 시도
      if (!canvas) {
        this.$nextTick(() => {
          this.initCanvas();
        });
        this.removeProcess(process);
        return;
      }
      
      this.paper.setup(canvas);
      this.paper.view.viewSize = [
        this.paper.view.size.width,
        window.innerHeight
      ];
      this.paper.activate();

      this.image.raster = new paper.Raster(this.image.url);
      this.image.raster.onLoad = () => {
        let width = this.image.raster.width;
        let height = this.image.raster.height;

        this.image.raster.sendToBack();
        
        // fit을 다음 틱에 실행하여 DOM이 완전히 렌더링된 후 실행
        this.$nextTick(() => {
          this.fit();
        });
        this.image.ratio = (width * height) / 1000000;

        let tempCtx = document.createElement("canvas").getContext("2d");
        tempCtx.canvas.width = width;
        tempCtx.canvas.height = height;
        tempCtx.drawImage(this.image.raster.image, 0, 0);

        this.image.data = tempCtx.getImageData(0, 0, width, height);
        let fontSize = width * 0.025;

        let positionTopLeft = new paper.Point(
          -width / 2,
          -height / 2 - fontSize * 0.5
        );
        this.text.topLeft = new paper.PointText(positionTopLeft);
        this.text.topLeft.fontSize = fontSize;
        this.text.topLeft.fillColor = "white";
        this.text.topLeft.content = this.image.filename;

        let positionTopRight = new paper.Point(
          width / 2,
          -height / 2 - fontSize * 0.4
        );
        this.text.topRight = new paper.PointText(positionTopRight);
        this.text.topRight.justification = "right";
        this.text.topRight.fontSize = fontSize;
        this.text.topRight.fillColor = "white";
        this.text.topRight.content = width + "x" + height;

        this.loading.image = false;
      };
      this.removeProcess(process);
    },
    setPreferences(preferences) {
      let refs = this.$refs;

      refs.bbox.setPreferences(preferences.bbox || preferences.polygon || {});
      refs.polygon.setPreferences(preferences.polygon || {});
      refs.select.setPreferences(preferences.select || {});
      refs.magicwand.setPreferences(preferences.magicwand || {});
      refs.eraser.setPreferences(preferences.eraser || {});
    },
    getData(callback, options = {}) {
      let process = "Loading Image";
      const silent = options.silent === true;
      if (!silent) {
        this.addProcess(process);
        this.loading.data = true;
      }
      return axios
        .get("/api/annotator/data/" + this.image.id)
        .then(response => {
          let data = response.data;

          this.loading.data = false;
          // Set image data
          this.image.metadata = data.image.metadata || {};
          this.image.filename = data.image.file_name;
          this.image.next = data.image.next;
          this.image.previous = data.image.previous;
          this.image.categoryIds = data.image.category_ids || [];
          
          this.image.original_id = this.image.id;
          this.image.prediction_status = data.image.prediction_status;
          this.image.predicted = data.image.predicted;
          this.image.results = data.image.results;
          this.image.results_list_id = [];
          for (const [product_code, res] of Object.entries(data.image.results)) {
            product_code;
            // 멀티페이지: ids 배열 우선, 하위호환: 단일 id
            var self = this
            if (res.ids && res.ids.length > 0) {
              res.ids.forEach(function(rid) { self.image.results_list_id.push(rid) })
            } else if (res.id) {
              self.image.results_list_id.push(res.id)
            }
          }
              
          this.annotating = data.image.annotating || [];

          // Set other data
          this.dataset = data.dataset;
          this.categories = data.categories;

          // Update status

          this.setDataset(this.dataset);

          let preferences = data.preferences;
          this.setPreferences(preferences);

          if (this.text.topLeft != null) {
            this.text.topLeft.content = this.image.filename;
          }

          this.$nextTick(() => {
            this.showAll();
          });

          if (callback != null) callback();
        })
        .catch(error => {
          if (silent) {
            throw error;
          }
          this.axiosReqestError(
            "Could not find requested image",
            "Redirecting to previous page."
          );
          this.$router.go(-1);
        })
        .finally(() => {
          if (!silent) this.removeProcess(process);
        });
    },
    onCategoryClick(indices) {
      this.current.annotation = indices.annotation;
      this.current.category = indices.category;
      if (!indices.hasOwnProperty('keypoint')) {
        indices.keypoint = -1;
      }
      if (indices.keypoint !== -1) {
        this.current.keypoint = indices.keypoint;
        let kpTool = this.$refs.keypoint;
        let selectTool = this.$refs.select;
        let category = this.$refs.category[this.current.category];
        let annotation = category.$refs.annotation[this.current.annotation];
        annotation.showKeypoints = true;
        let keypoints = annotation.keypoints;
        if (keypoints._labelled[indices.keypoint + 1]) {
          let indexLabel = String(this.current.keypoint + 1);
          let keypoint = keypoints._labelled[indexLabel];
          keypoint.selected = true;
          this.activeTool = selectTool;
          this.activeTool.click();
        } else {
          this.currentAnnotation.keypoint.next.label = String(indices.keypoint + 1);
          this.activeTool = kpTool;
          this.activeTool.click();
        }
      }
    },
    onKeypointsComplete() {
      this.currentAnnotation.keypoint.next.label = -1;
      this.activeTool = this.$refs.select;
      this.activeTool.click();
    },
    getCategory(index) {
      if (index == null) return null;
      if (index < 0) return null;

      let ref = this.$refs.category;

      if (ref == null) return null;
      if (ref.length < 1 || index >= ref.length) return null;

      return this.$refs.category[index];
    },
    // Current Annotation Operations
    uniteCurrentAnnotation(compound, simplify = true, undoable = true, isBBox = false) {
      if (this.currentAnnotation == null) return;
      this.currentAnnotation.unite(compound, simplify, undoable, isBBox);
    },
    subtractCurrentAnnotation(compound, simplify = true, undoable = true) {
      if (this.currentCategory == null) return;
      this.currentAnnotation.subtract(compound, simplify, undoable);
    },

    selectLastEditorTool() {
      this.activeTool = localStorage.getItem("editorTool") || "Select";
    },

    setCursor(newCursor) {
      this.cursor = newCursor;
    },
    incrementCategory() {
      if (this.current.category >= this.categories.length - 1) {
        this.current.category = -1;
      } else {
        this.current.category += 1;
        if (this.currentKeypoint) {
          this.currentAnnotation.onAnnotationKeypointClick(this.current.keypoint);
        }
      }
    },
    decrementCategory() {
      if (this.current.category === -1) {
        this.current.category = this.categories.length - 1;
        let annotationCount = this.currentCategory.category.annotations.length;
        if (annotationCount > 0) {
          this.current.annotation = annotationCount - 1;
        }
      } else {
        this.current.category -= 1;
      }
    },
    incrementAnnotation() {
      let annotationCount = this.currentCategory.category.annotations.length;
      if (this.current.annotation === annotationCount - 1) {
        this.incrementCategory();
        this.current.annotation = -1;
      } else {
        this.current.annotation += 1;
        if (this.currentAnnotation != null && this.currentAnnotation.showKeypoints) {
          this.current.keypoint = 0;
          this.currentAnnotation.onAnnotationKeypointClick(this.current.keypoint);
        } else {
          this.current.keypoint = -1;
        }
      }
    },
    decrementAnnotation() {
      let annotationCount = this.currentCategory.category.annotations.length;
      if (this.current.annotation === -1) {
        this.current.annotation = annotationCount - 1;
      } else if (this.current.annotation === 0) {
        this.decrementCategory();
      } else {
        this.current.annotation -= 1;
        if (this.currentAnnotation != null && this.currentAnnotation.showKeypoints) {
          this.current.keypoint = this.currentAnnotation.keypointLabels.length - 1;
          this.currentAnnotation.onAnnotationKeypointClick(this.current.keypoint);
        } else {
          this.current.keypoint = -1;
        }
      }
    },
    incrementKeypoint() {
      let keypointCount = this.currentAnnotation.keypointLabels.length;
      if (this.current.keypoint === keypointCount - 1) {
        this.incrementAnnotation();
      } else {
        this.current.keypoint += 1;
      }
      if (this.currentKeypoint != null) {
        this.currentAnnotation.onAnnotationKeypointClick(this.current.keypoint);
      }
    },
    decrementKeypoint() {
      if (this.current.keypoint === 0) {
        this.decrementAnnotation();
      } else {
        this.current.keypoint -= 1;
      }
      if (this.currentKeypoint != null) {
        this.currentAnnotation.onAnnotationKeypointClick(this.current.keypoint);
      }
    },
    moveUp() {
      if (this.currentCategory != null) {
        if (this.currentAnnotation != null) {
          if (this.currentKeypoint != null) {
            this.decrementKeypoint();
          } else if (this.currentAnnotation.showKeypoints && this.current.keypoint == -1) {
            this.decrementKeypoint();
          } else {
            this.decrementAnnotation();
          }
        } else if (this.current.annotation == -1) {
          this.decrementAnnotation();
        } else {
          this.decrementCategory();
        }
      } else {
        this.decrementCategory();
      }
    },
    moveDown() {
      if (this.currentCategory != null) {
        if (this.currentAnnotation != null) {
          if (this.currentKeypoint != null) {
            this.incrementKeypoint();
          } else if (this.currentAnnotation.showKeypoints && this.current.keypoint == -1) {
            this.incrementKeypoint();
          } else {
            this.incrementAnnotation();
          }
        } else if (this.current.annotation == -1) {
          this.incrementAnnotation();
        } else {
          this.incrementCategory();
        }
      } else {
        this.incrementCategory();
      }
    },
    stepIn() {
      if (this.currentCategory != null) {
        if (!this.currentCategory.isVisible) {
          this.currentCategory.isVisible = true;
          this.current.annotation = 0;
          this.currentAnnotation.showKeypoints = false;
          this.current.keypoint = -1;
        } else if (
          !this.currentCategory.showAnnotations &&
          this.currentAnnotationLength > 0
        ) {
          this.currentCategory.showAnnotations = true;
          this.current.annotation = 0;
          this.currentAnnotation.showKeypoints = false;
          this.current.keypoint = -1;
        } else if (
          !this.currentAnnotation.showKeypoints &&
          this.currentAnnotation.keypointLabels.length > 0
        ) {
          this.currentAnnotation.showKeypoints = true;
          this.current.keypoint = 0;
          this.currentAnnotation.onAnnotationKeypointClick(this.current.keypoint);
        }
      }
    },
    stepOut() {
      if (this.currentCategory != null) {
        if (
          this.currentAnnotation != null &&
          this.currentAnnotation.showKeypoints
        ) {
          this.currentAnnotation.showKeypoints = false;
          this.current.keypoint = -1;
        } else if (this.currentCategory.showAnnotations) {
          this.currentCategory.showAnnotations = false;
          this.current.annotation = -1;
        } else if (this.currentCategory.isVisible) {
          this.currentCategory.isVisible = false;
        }
      }
    },
    scrollElement(element) {
      element.scrollIntoView({
        behavior: "smooth",
        block: "center"
      });
    },
    showAll() {
      if (this.$refs.category == null) return;

      this.$refs.category.forEach(category => {
        category.isVisible = category.category.annotations.length > 0;
      });
    },
    hideAll() {
      if (this.$refs.category == null) return;

      this.$refs.category.forEach(category => {
        category.isVisible = false;
        category.showAnnotations = false;
      });
    },
    findCategoryByName(categoryName) {
      let categoryComponent = this.$refs.category.find(
        category =>
          category.category.name.toLowerCase() === categoryName.toLowerCase()
      );
      if (!categoryComponent) return null;
      return categoryComponent.category;
    },
    addAnnotation(categoryName, segments, keypoints, isbbox=false) {
      segments = segments || [];
      keypoints = keypoints || [];

      if (keypoints.length == 0 && segments.length == 0) return;

      let category = this.findCategoryByName(categoryName);
      if (category == null) return;

      Annotations.create({
        image_id: this.image.id,
        category_id: category.id,
        segmentation: segments,
        keypoints: keypoints,
        isbbox: isbbox
      }).then(response => {
        let annotation = response.data;
        category.annotations.push(annotation);
      });
    },

    updateAnnotationCategory(annotation, oldCategory, newCategoryName) {
      const newCategory = this.findCategoryByName(newCategoryName);
      if (!newCategory || !annotation) return;

      Annotations.update(annotation.id, { category_id: newCategory.id }).then(
        response => {
          let newAnnotation = {
            ...response.data,
            ...annotation,
            metadata: response.data.metadata,
            category_id: newCategory.id
          };

          if (newAnnotation) {
            oldCategory.annotations = oldCategory.annotations.filter(
              a => a.id !== annotation.id
            );
            newCategory.annotations.push(newAnnotation);
          }
        }
      );
    },

    removeFromAnnotatingList() {
      if (this.user == null) return;

      var index = this.annotating.indexOf(this.user.username);
      //Remove self from list
      if (index > -1) {
        this.annotating.splice(index, 1);
      }
    },
    nextImage() {
      if(this.image.next != null)
        this.$refs.filetitle.route(this.image.next);
    },
    previousImage() {
      if(this.image.previous != null)
        this.$refs.filetitle.route(this.image.previous);
    },
    goBackToList() {
      this.$router.go(-1);
    },
    handleSelectToolClick() {
      if (this.$refs.select) {
        this.$refs.select.click();
      }
    },
    handleInferenceClick() {
      if (this.$refs.inference) {
        this.$refs.inference.click();
      }
    },
    isInferenceTerminal(status) {
      return TERMINAL_PREDICTION_STATUSES.includes(status);
    },
    stopInferenceStatusPolling() {
      if (this.inferencePollingTimer) {
        clearTimeout(this.inferencePollingTimer);
        this.inferencePollingTimer = null;
      }
    },
    startInferenceStatusPolling() {
      this.stopInferenceStatusPolling();
      this.inferencePollingStartedAt = Date.now();
      const timeoutMs = 10 * 60 * 1000;
      const intervalMs = 5000;
      const poll = () => {
        this.getData(null, { silent: true })
          .then(() => {
            const status = this.image.prediction_status || '';
            if (this.isInferenceTerminal(status)) {
              this.stopInferenceStatusPolling();
              if (status === FAILED) {
                this.$toastr.error('AI analysis failed', 'Inference');
              } else {
                this.$toastr.success('Analysis complete', 'Inference');
              }
              return;
            }
            if (Date.now() - this.inferencePollingStartedAt >= timeoutMs) {
              this.stopInferenceStatusPolling();
              this.$toastr.warning('Analysis is still running. Refresh later to check status.', 'Inference');
              return;
            }
            this.inferencePollingTimer = setTimeout(poll, intervalMs);
          })
          .catch(() => {
            if (Date.now() - this.inferencePollingStartedAt < timeoutMs) {
              this.inferencePollingTimer = setTimeout(poll, intervalMs);
              return;
            }
            this.stopInferenceStatusPolling();
            this.$toastr.warning('Analysis is still running. Refresh later to check status.', 'Inference');
          });
      };
      this.inferencePollingTimer = setTimeout(poll, intervalMs);
    },

    handleCenterClick() {
      if (this.$refs.center) {
        this.$refs.center.click();
      }
    },
    handleDownloadClick() {
      if (this.$refs.download) {
        this.$refs.download.click();
      }
    },
    handleDeleteClick() {
      if (this.$refs.delete) {
        this.$refs.delete.click();
      }
    }
  },
  watch: {
    doneLoading(done) {
      if (done) {
        if (this.loading.loader) {
          this.loading.loader.hide();
        }
      }
    },
    currentCategory() {
      if (this.currentCategory != null) {
        if (
          this.currentAnnotation == null ||
          !this.currentCategory.showAnnotations
        ) {
          let element = this.currentCategory.$el;
          this.scrollElement(element);
        }
      }
    },
    currentAnnotation(newElement) {
      if (newElement != null) {
        if (newElement.showAnnotations) {
          let element = newElement.$el;
          this.scrollElement(element);
        }
      }
    },
    "current.category"(cc) {
      if (cc < -1) this.current.category = -1;
      let max = this.categories.length;
      if (cc > max) {
        this.current.category = -1;
      }
    },
    "current.annotation"(ca) {
      if (ca < -1) this.current.annotation = -1;
      if (this.currentCategory != null) {
        let max = this.currentAnnotationLength;
        if (ca > max) {
          this.current.annotations = -1;
        }
      }
    },
    "current.keypoint"(sk) {
      if (sk < -1) this.current.keypoint = -1;
      if (this.currentCategory != null) {
        let max = this.currentAnnotationLength;
        if (sk > max) {
          this.current.keypoint = -1;
        }
      }
    },
    annotating() {
      this.removeFromAnnotatingList();
    },
    user() {
      this.removeFromAnnotatingList();
    }
  },
  computed: {
    doneLoading() {
      return !this.loading.image && !this.loading.data;
    },
    currentAnnotationLength() {
      if (this.currentCategory == null) return null;
      return this.currentCategory.category.annotations.length;
    },
    currentKeypointLength() {
      if (this.currentAnnotation == null) return null;
      return this.currentAnnotation.annotation.keypoints.length;
    },
    currentCategory() {
      return this.getCategory(this.current.category);
    },
    currentAnnotation() {
      if (this.currentCategory == null) {
        return null;
      }
      return this.currentCategory.getAnnotation(this.current.annotation);
    },
    currentKeypoint() {
      if (this.currentCategory == null) {
        return null;
      }
      if (this.currentAnnotation == null 
      || this.currentAnnotation.keypointLabels.length === 0 
      || !this.currentAnnotation.showKeypoints)
      {
        return null;
      }
      if (this.current.keypoint == -1) {
        return null;
      }
      return {
        label: [String(this.current.keypoint + 1)],
        visibility: this.currentAnnotation.getKeypointVisibility(this.current.keypoint)
      };
    },
    user() {
      return this.$store.getters["user/user"];
    }
  },
  beforeRouteLeave(to, from, next) {
    this.stopInferenceStatusPolling();
    this.current.annotation = -1;

    this.$nextTick(() => {
      this.save(next);
    });
  },
  beforeDestroy() {
    this.stopInferenceStatusPolling();
  },
  mounted() {
    this.setDataset(null);
    this.initCanvas();
    this.getData();
  },
  created() {
    this.paper = new paper.PaperScope();
    this.image.id = this.identifier;
    this.image.url = "/api/image/" + this.image.id;
  }
};
</script>

<style scoped>
    
.thumbnail {
    width: 230px; 
    max-width: 230px;
}    
    
.alert {
  bottom: 0;
  width: 50%;
  display: block;
  margin-left: auto;
  margin-right: auto;
}

/* width */
::-webkit-scrollbar {
  width: 7px;
}

/* Track */
::-webkit-scrollbar-track {
  box-shadow: inset 0 0 5px grey;
  border-radius: 10px;
}

/* Handle */
::-webkit-scrollbar-thumb {
  background: white;
  border-radius: 10px;
}

/* Handle on hover */
::-webkit-scrollbar-thumb:hover {
  background: #9feeb0;
}

/* 최상위 컨테이너: Flexbox 적용 */
.layout-container {
  display: flex;
  width: 100vw;        /* 화면 전체 너비 */
  height: 100vh;       /* 화면 전체 높이 (매우 중요) */
  overflow: hidden;
}

/* 패널 설정 */
.left-panel {
  width: 180px;
  min-width: 180px;
  padding-top: 40px;
  background-color: #4b5162;
  height: 100%;
  box-shadow: 5px 0 10px rgba(0,0,0,0.2);
  z-index: 10;
  overflow-y: auto;
}

.right-panel {
  width: 250px;
  min-width: 250px;
  padding-top: 40px;
  background-color: #4b5162;
  height: 100%;
  z-index: 10;
  overflow-y: auto;
}

/* 가운데 패널 및 내부 자식들 높이 강제 설정 */
.middle-panel {
  flex: 1;             /* 남은 공간 모두 차지 */
  background-color: #7c818c;
  position: relative;  /* 자식 요소 absolute 배치를 위해 */
  height: 100%;        /* 부모 높이 상속 */
  overflow: hidden;
}

/* v-touch가 생성하는 div를 타겟팅 */
.middle-panel > div {
  width: 100%;
  height: 100%;
}

/* 실제 캔버스를 감싸는 프레임 */
.frame {
  width: 100%;
  height: 100%;
  margin: 0;
  display: flex;          /* 캔버스 중앙 정렬을 위해 */
  justify-content: center;
  align-items: center;
}

/* 캔버스 자체 */
.canvas {
  width: 100%;
  height: 100%;
  display: block;
}

#image {
  position: absolute;
}

.sidebar-section {
  width: 100%;
  padding-left: 5px;
  padding-right: 5px;
  overflow: auto;
}

.sidebar-title {
  color: white;
}

/* Tool section */
.tool-section {
  margin: 5px;
  border-radius: 5px;
  background-color: #383c4a;
  padding: 0 5px 5px 5px;
  overflow: auto;
}

.meta-input {
  padding: 3px;
  background-color: inherit;
  width: 100%;
  height: 100%;
  border: none;
}

.meta-item {
  background-color: inherit;
  height: 30px;
  border: none;
}

.status-icon {
  font-size: 150px;
  color: white;
  position: absolute;
  left: calc(50% - 75px);
  top: calc(50% - 75px);
}

.search {
  width: 100%;
  height: 18px;
  color: white;
  background-color: rgba(255, 255, 255, 0.1);
  border: none;
  text-align: center;
  border-radius: 4px;
}

.back-button {
  width: 50px;
  height: 50px;
  margin: 5px auto;
  display: block;
  background-color: #383c4a;
  color: white;
  border: none;
  border-radius: 5px;
  cursor: pointer;
  font-size: 20px;
}

.tool-item {
  display: flex;
  align-items: center;
  padding: 5px 10px;
  gap: 10px;
  cursor: pointer;
}

.first-tool-item {
  margin-top: 20px;
}

.tool-item > div {
  flex-shrink: 0;
}

.tool-item > button {
  flex-shrink: 0;
}

.tool-label {
  color: white;
  font-size: 13px;
  white-space: nowrap;
  flex: 1;
  user-select: none;
  font-family: "Avenir", Helvetica, Arial, sans-serif;
}
</style>

<!-- Icon color classes for CSP compliance - must be global (not scoped) -->
<style>
.fa.icon-active {
  color: #2ecc71 !important;
}

.fa.icon-enabled {
  color: white !important;
}

.fa.icon-disabled {
  color: gray !important;
}

.fa.icon-toggle {
  color: red !important;
}
</style>